var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoungmale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.5 0C187.05 0 241 53.95 241 120.5C241 187.05 187.05 241 120.5 241C53.95 241 0 187.05 0 120.5C0 53.95 53.95 0 120.5 0Z",
    fill: "#F35B04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.346 169.165C155.346 169.165 199.24 172.522 204 190.362V205.2C204 205.2 166.493 237 114.263 237C74.3612 237 39.0002 205.2 39.0002 205.2V194.602C39.0002 194.602 38.4862 174.611 85.5382 169.165H155.346Z",
    fill: "#B6CAD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.346 143.729H138.423V171.285C138.423 171.285 130.189 175.524 121.5 175.524C111.276 175.524 100.346 171.285 100.346 171.285V143.729Z",
    fill: "#F5BAC3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5373 124.652C85.5373 124.652 84.4193 146.147 113.037 156.447C113.037 156.447 148.485 164.315 157.461 126.772L159.576 111.934C159.576 111.934 166.315 113.14 170.153 105.575C170.153 105.575 172.661 92.5489 159.576 90.7369L161.691 61.061C161.691 61.061 158.156 54.697 153.23 52.583C148.304 50.468 144.254 47.1269 136.307 48.3429C128.359 49.5599 124.309 51.366 113.037 50.463C101.765 49.56 89.7683 52.583 89.7683 52.583C89.7683 52.583 82.9823 61.027 81.3073 71.66C79.8213 81.091 83.4223 92.857 83.4223 92.857C83.4223 92.857 71.4253 89.5209 72.8453 105.575C72.8453 105.575 75.0513 113.443 83.4223 111.934",
    fill: "#FFE1D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1918 92.8571C79.1918 92.8571 79.0958 92.2861 78.9588 91.2471C78.1688 85.2301 76.0268 63.5211 83.4228 46.2241C84.0268 44.7101 89.8598 24.1131 121.5 25.0271C123.918 25.0271 159.97 22.9021 163.808 56.8221C163.808 56.8221 167.223 67.4151 163.808 92.8571H157.462V65.3011C157.462 65.3011 153.019 52.2751 142.654 58.9421C142.654 58.9421 128.843 78.6201 98.2308 56.8221C98.2308 56.8221 84.1178 55.0001 85.5378 73.7801V94.9761",
    fill: "#0D0B0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.346 143.729C100.346 143.729 103.745 169.13 87.6543 167.046C87.6543 167.046 118.552 207.284 151.115 169.165C151.115 169.165 138.649 167.54 138.423 143.729H100.346Z",
    fill: "#FFE1D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4238 169.165C83.4238 169.165 91.9348 192.093 117.27 192.482C117.27 192.482 150.5 193.5 163 170L151.5 169C151.5 169 128.602 201.985 87.6548 167.046L83.4238 169.165Z",
    fill: "#53B8F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoungmale);
export default __webpack_public_path__ + "static/media/youngmale.8c3bdfce26bcff78218bf0ef6c52eb05.svg";
export { ForwardRef as ReactComponent };